import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { MainStore, PlaybackState } from "../../../store";
import { seconds_to_pixels } from "../../../util/time_position_conversion";
import { getZoomProportion } from "../../../util/zoom_levels";
import { Container } from "./styles";

function pixelToTransform(px: number, py: number = 0) {
  return `translateX(${px}px) translateY(${py}px)`;
}
export let Locator = () => {
  const zoomLevel = useSelector<MainStore, number>(
    state => state.uiState.zoomLevel
  );
  const locatorTime = useSelector<MainStore, number>(
    state => state.editorState.locatorTime
  );
  const playbackState = useSelector<MainStore, PlaybackState>(
    state => state.editorState.playbackState
  );
  const trackDurationSeconds = useSelector<MainStore, number>(
    state => state.project.customMixInfo.length
  );
  const outMarkerTime = useSelector<MainStore, number>(
    state => state.project.markers.out.songTime
  );

  // this handles scrolling along with the locator position, screen by screen
  useEffect(() => {
    const lanesAreaElement = document.getElementById("lanes-area-container");
    const xLocator = seconds_to_pixels(locatorTime) * getZoomProportion(zoomLevel);
    const xScreenLeft = lanesAreaElement.scrollLeft;
    const screenWidth = lanesAreaElement.clientWidth;
    const xScreenRight = xScreenLeft + screenWidth;
    const maxSongTime = Math.max(outMarkerTime, trackDurationSeconds);
    const songLengthPixels = seconds_to_pixels(maxSongTime) * getZoomProportion(zoomLevel);

    if (playbackState === PlaybackState.PLAYING) {
      if (xLocator < xScreenLeft || xLocator > xScreenRight) {
        const desiredX = Math.min(songLengthPixels - screenWidth, Math.max(0, xLocator - 0.15 * screenWidth));
        lanesAreaElement.scroll({
          left: desiredX,
          behavior: "smooth"
        })
      }
    }
  }, [locatorTime, playbackState, zoomLevel, outMarkerTime, trackDurationSeconds]);

  return (
    <Container
      id="locator"
      style={{
        transform: pixelToTransform(seconds_to_pixels(locatorTime) * getZoomProportion(zoomLevel))
      }}
      playbackState={playbackState}
    ></Container>
  );
};
